import {VueConstructor} from 'vue';
import {AxiosError} from 'axios';

export default {
  install(Vue: VueConstructor,) {
    Vue.prototype.$log = (log: string) => {
      console.log(log);
    };

    Vue.prototype.errorHandler = (err: AxiosError, message?: string) => {
      console.error(err);
      const data = err.response?.data;
      const apiMessage = data?.message;
      const errorMessage =
        apiMessage && (apiMessage !== data?.key || !data?.description) ? apiMessage : '';
      let msg = errorMessage || message || '';
      const description = data?.description;
      if (description) {
        msg = msg.concat(' ' + description).trim();
      }

      if (msg && Vue.prototype.$snackbarService) {
        Vue.prototype.$snackbarService.openErrorSnackbar(msg);
      }
    };

    Vue.prototype.$clipboard = (str: string, showSnackbar = true) => {
      if (!str) {
        return;
      }
      const openSuccessSnackbar = () => {
        if (showSnackbar) {
          Vue.prototype.$snackbarService.openSuccessSnackbar(Vue.prototype.$i18n.useMain.CLIPBOARD);
        }
      };
      // Fallback dla przeglądarek bez navigator.clipboard. Nie zadziała przy otwartym
      // v-dialog: retain-focus Vuetify odbiera focus textarea zanim wykona się 'copy'.
      const copyWithExecCommand = (): boolean => {
        const el = document.createElement('textarea');
        el.value = str;
        document.body.appendChild(el);
        el.select();
        const copied = document.execCommand?.('copy') ?? false;
        document.body.removeChild(el);
        return copied;
      };
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(str)
          .then(openSuccessSnackbar)
          .catch(() => {
            if (copyWithExecCommand()) {
              openSuccessSnackbar();
            }
          });
      } else if (copyWithExecCommand()) {
        openSuccessSnackbar();
      }
    };

    Vue.prototype.$sync = function(key: string, value: any) {
      this.$emit(`update:${key}`, value);
    };
  },
};
